import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { faSave } from '@fortawesome/free-regular-svg-icons/faSave';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const FormTopTags = ({
  topTags,
}) => {
  const { tags: stored = [] } = topTags || {};
  const [res, req] = useHttpStatus();
  const [tags, setTags] = useState(stored.join(', '));
  const { t } = useTranslation();

  return (
    <form onSubmit={(e) => {
      e.preventDefault();

      req({
        url: '/api/quiz/top-tags',
        method: 'POST',
        data: {
          tags: tags.split(',').map((s) => s.trim()),
        },
      });
    }}>
      <label>{`${t('Top Tags')} (${t('Comma seperated')})`}</label>
      <div className="input-group">
        <input
          className="form-control"
          onChange={(e) => setTags(e.target.value)}
          value={tags}
        />
        <div className="input-group-append">
          <FormHttpBtn
            res={res}
            type="submit"
            className="btn-primary"
            icon={faSave}
          >{t('Save')}</FormHttpBtn>
        </div>
      </div>
    </form>
  );
};

export default FormTopTags;
